import {
  Box,
  Button,
  DialogActions,
  DialogContentText,
  DialogTitle,
  Typography,
  styled as muiStyled,
  TableContainer as MuiTableContainer,
  Table as MuiTable,
} from '@mui/material';
import { abyssColors } from '@/theme/colors';

export const TablePaginationContainer = muiStyled(Box)(() => ({
  display: 'flex',
  justifyContent: 'flex-end',
}));

export const TableHeadCell = muiStyled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
}));

export const ColumnTitleTypography = muiStyled(Typography)(() => ({
  fontWeight: 700,
  fontSize: '1.2rem',
  lineHeight: '16px',
  letterSpacing: '0.5px',
  color: abyssColors.primary[700],
  textTransform: 'uppercase',
}));

type ButtonProps = {
  contained?: boolean;
  compact?: boolean;
};

export const ActionButton = muiStyled(Button)(({ contained, compact }: ButtonProps) => ({
  padding: compact ? '0.8rem 1.2rem' : '0.8rem 1.8rem',
  height: '3.4rem',
  borderRadius: '0.4rem',
  fontSize: '1.4rem',
  background: contained ? abyssColors.primary[500] : abyssColors.neutral[50],
  color: contained ? abyssColors.neutral[50] : abyssColors.primary[500],
  boxShadow: 'none',
  textTransform: 'none',
  width: 'fit-content',
  lineHeight: 'normal',
  marginLeft: '0px !important',
  gap: '0.6rem',
  '&:disabled': {
    background: contained ? abyssColors.neutral[300] : abyssColors.neutral[50],
    color: contained ? abyssColors.neutral[50] : abyssColors.primary[300],
  },
  '&:hover': {
    background: contained ? abyssColors.primary[400] : abyssColors.neutral[50],
  },
}));

export const Header = muiStyled(DialogTitle)(() => ({
  padding: '3.2rem',
  paddingBottom: '2.4rem',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
}));

export const SubHeading = muiStyled(DialogContentText)(() => ({
  paddingBottom: '2rem',
}));

export const TitleText = muiStyled(Typography)(() => ({
  fontWeight: 600,
  fontSize: '2rem',
  lineHeight: 'normal',
  color: abyssColors.primary[500],
}));

export const Footer = muiStyled(DialogActions)(() => ({
  height: '6.2rem',
  padding: '1.6rem 3.2rem',
  borderTop: '1px solid rgba(101, 130, 164, 0.20)',
}));

export const DialogActionButton = muiStyled(ActionButton)(() => ({
  fontSize: '1.2rem',
  height: '3rem',
  padding: '0px 30px',
}));

export const StyledTableContainer = muiStyled(MuiTableContainer)(() => ({
  position: 'relative',
  minHeight: 320,
  maxHeight: 820,
  display: 'flex',
  flexDirection: 'column',
}));

export const ScrollableBox = muiStyled(Box)(() => ({
  overflowX: 'auto',
  overflowY: 'auto',
  flexGrow: 1,
}));

export const StyledTable = muiStyled(MuiTable)(() => ({
  '& .MuiTableHead-root': {
    position: 'sticky',
    top: 0,
    zIndex: 2,
    backgroundColor: 'background.paper',
  },
}));

export const PaginationBox = muiStyled(Box)(() => ({
  alignSelf: 'flex-end',
  marginTop: 1,
  paddingBottom: 2,
  position: 'sticky',
  bottom: 0,
  backgroundColor: 'background.paper',
  zIndex: 1,
}));
